// @ts-nocheck
import React, { FunctionComponent, useMemo, useState } from 'react'
import { ModalLayout } from 'Components/index'
import { Modal } from 'reactstrap'

import { getEventDetails, getOpenedCampaign } from 'Redux/selectors/influencer'
import {
  EventDetails,
  InfluencerCampaign,
  InfluencerEventStatus,
} from 'Redux/reducers/influencerReducer'
import { useDispatch, useSelector } from 'react-redux'
import {
  closeCampaignDetails,
  setEventDetails,
} from 'Redux/actions/influencerActions'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import { useTranslation } from 'react-i18next'
import { UploadVideo } from '../Footer/UploadVideo'
import { Track } from '../Track'
import { TrackDetails } from '../TrackDetails'
import { RewardComponent } from '../RewardComponent'
import { ArtistComment } from '../ArtistComment'
import { Awaiting } from '../Footer/Awaiting'
import { Canceled } from '../Footer/Canceled'
import { Complete } from '../Footer/Complete'
import { AcceptTrack } from '../Footer/AcceptTrack'
import { Content, TitleDetailsModal, TitleWrapper } from './styles'

const footers = {
  [InfluencerEventStatus.ACCEPTED]: UploadVideo,
  [InfluencerEventStatus.AWAITING_REVIEW]: Awaiting,
  [InfluencerEventStatus.AWAITING_MODERATOR_REVIEW]: Awaiting,
  [InfluencerEventStatus.APPROVED_BY_ARTIST]: Complete,
  [InfluencerEventStatus.APPROVED_AUTOMATICALLY]: Complete,
  [InfluencerEventStatus.APPROVED_BY_ADMIN]: Complete,
  [InfluencerEventStatus.CANCELED]: Canceled,
  [InfluencerEventStatus.CANCELED_BY_ARTIST]: Canceled,
  [InfluencerEventStatus.DECLINED]: Canceled,
}

export const DetailsModal: FunctionComponent = () => {
  const campaign = useSelector(getOpenedCampaign)
  const { t } = useTranslation()

  const [actualEntity, setActualEntity] = useState<
    InfluencerCampaign | EventDetails
  >()

  const dispatch = useDispatch()

  const onClose = () => {
    dispatch(closeCampaignDetails())
    dispatch(setEventDetails(null))
  }
  const status = actualEntity?.status
  const eventDetails = useSelector(getEventDetails)

  const Footer = footers[eventDetails?.status] || AcceptTrack

  const modalContent = useMemo(() => {
    if (eventDetails) {
      setActualEntity(eventDetails)
    } else {
      setActualEntity(campaign)
    }

    if (actualEntity) {
      return (
        <Content>
          <Mobile>
            <TitleWrapper>
              <button
                className="modal__mobile--close lnr lnr-arrow-left"
                type="button"
                onClick={onClose}
              />
              <TitleDetailsModal>
                {t('influencer.listenTrack')}
              </TitleDetailsModal>
            </TitleWrapper>
          </Mobile>
          <Desktop>
            <TitleDetailsModal>{t('influencer.listenTrack')}</TitleDetailsModal>
          </Desktop>
          <Track
            audio={{
              url: actualEntity.trackPlayUrl,
              cover: actualEntity.trackCoverUrl,
              authorName: actualEntity.trackAuthorName,
              trackName: actualEntity.trackTitle,
              link: actualEntity.trackUrl,
            }}
          />
          <TrackDetails
            dance={actualEntity.isDanceRequested}
            genres={actualEntity.genres.map(
              item => item.slice(0, 1).toUpperCase() + item.slice(1)
            )}
            status={actualEntity.status}
            vocal={actualEntity.languages}
            stars={actualEntity.stars}
          />

          {(status === InfluencerEventStatus.APPROVED_BY_ARTIST ||
            status === InfluencerEventStatus.APPROVED_AUTOMATICALLY ||
            status === InfluencerEventStatus.APPROVED_BY_ADMIN) && (
            <RewardComponent
              reward={actualEntity.reward}
              stars={actualEntity.stars}
            />
          )}

          <ArtistComment
            comment={actualEntity.campaignArtistComment || actualEntity.comment}
          />
          {Footer && <Footer t={t} onClose={onClose} />}
        </Content>
      )
    }
    return null
  }, [campaign, eventDetails, actualEntity])

  return (
    <>
      <Desktop>
        <ModalLayout
          content={t('influencer.tracksDetails')}
          visible={!!campaign || !!eventDetails}
          width={600}
          handleClose={onClose}
        >
          {modalContent}
        </ModalLayout>
      </Desktop>
      <Mobile>
        <Modal
          fade={false}
          className="modal__mobile-dialog"
          isOpen={!!campaign || !!eventDetails}
          modalClassName="modal__mobile"
          toggle={onClose}
        >
          {modalContent}
        </Modal>
      </Mobile>
    </>
  )
}
